import { render, staticRenderFns } from "./CourseDayLeadersRow.vue?vue&type=template&id=a3028438&scoped=true&lang=pug&"
import script from "./CourseDayLeadersRow.vue?vue&type=script&lang=js&"
export * from "./CourseDayLeadersRow.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayLeadersRow.vue?vue&type=style&index=0&id=a3028438&lang=scss&scoped=true&"
import style1 from "./CourseDayLeadersRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3028438",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
